import {floatPriceFromFormatted} from '@optimaxdev/utils';

import {apiConfig} from 'libs/api/api';

import {
    DyAddToCartDataType,
    DyCommonCartDataType,
    DyCustomCartDataType,
    StateType,
} from './dynamicYieldTypes';

/**
 * Get Dynamic Yield Add Cart Data
 * @param {StateType} state - Application state
 * @returns {DyAddToCartDataType} - data
 */
export const getAddToCartData = (state: StateType): DyAddToCartDataType => {
    const {count, quoteItems, totals} = state.cart;
    const lastItem = quoteItems[quoteItems.length - 1];
    const currencyCode = apiConfig.hostStore?.getState()?.customer?.currency?.code || 'USD';

    return {
        cart: quoteItems.map(product => ({
            itemPrice: floatPriceFromFormatted(product.total),
            productId: product.product_sku,
            quantity: product.qty,
        })),
        currency: currencyCode,
        productId: lastItem.product_sku,
        quantity: count,
        size: (lastItem.frame && lastItem.frame.frameSize) || '',
        value: floatPriceFromFormatted(totals.total),
    };
};

/**
 * Get Dynamic Yield Add and Sync Cart Custom Data
 * @param {StateType} state - Application state
 * @returns {DyCustomCartDataType} - data
 */
export const getAddSyncCartDataCustom = (state: StateType): DyCustomCartDataType => {
    const {quoteItems} = state.cart;
    const lastItem = quoteItems[quoteItems.length - 1];
    return {
        full_sku: lastItem.sku,
        item_price: floatPriceFromFormatted(lastItem.total),
    };
};

/**
 * Get Dynamic Yield Remove and Sync Cart Custom Data
 * @param {StateType} state - Application state
 * @returns {DyCommonCartDataType} - data
 */
export const getRemoveSyncCartData = (state: StateType): DyCommonCartDataType => {
    const currencyCode = apiConfig.hostStore?.getState()?.customer?.currency?.code || 'USD';

    return {
        cart: state.cart.quoteItems.map(product => ({
            itemPrice: floatPriceFromFormatted(product.total),
            productId: product.product_sku,
            quantity: product.qty,
        })),
        currency: currencyCode,
    };
};
